var _rect, _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 241,
    viewBox: "0 0 240 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.2832,
    y: 47.5557,
    width: 126.726,
    height: 147.848,
    rx: 25.9111,
    fill: "url(#paint0_linear_839_26531)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7463 85.0783C84.7513 84.0734 86.1143 83.5088 87.5356 83.5088H144.696C146.117 83.5088 147.48 84.0734 148.485 85.0783C149.49 86.0833 150.055 87.4463 150.055 88.8676C150.055 90.2888 149.49 91.6519 148.485 92.6568C147.48 93.6618 146.117 94.2264 144.696 94.2264H87.5356C86.1143 94.2264 84.7513 93.6618 83.7463 92.6568C82.7413 91.6519 82.1768 90.2888 82.1768 88.8676C82.1768 87.4463 82.7413 86.0833 83.7463 85.0783Z",
    fill: "url(#paint1_linear_839_26531)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7463 113.659C84.7513 112.654 86.1143 112.089 87.5356 112.089H123.261C124.682 112.089 126.045 112.654 127.05 113.659C128.055 114.664 128.62 116.027 128.62 117.448C128.62 118.869 128.055 120.232 127.05 121.237C126.045 122.242 124.682 122.807 123.261 122.807H87.5356C86.1143 122.807 84.7513 122.242 83.7463 121.237C82.7413 120.232 82.1768 118.869 82.1768 117.448C82.1768 116.027 82.7413 114.664 83.7463 113.659Z",
    fill: "url(#paint2_linear_839_26531)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_839_26531)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.61,
    cy: 180.102,
    rx: 42.0072,
    ry: 42.0072,
    transform: "rotate(-180 174.61 180.102)",
    fill: "url(#paint3_linear_839_26531)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.654 180.102C132.654 156.93 151.438 138.146 174.61 138.146C197.782 138.146 216.566 156.93 216.566 180.102C216.566 203.274 197.782 222.059 174.61 222.059C151.438 222.059 132.654 203.274 132.654 180.102Z",
    stroke: "url(#paint4_linear_839_26531)",
    strokeOpacity: 0.1,
    strokeWidth: 0.101617
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.592 166.903C194.719 165.941 193.554 165.455 192.375 165.444C191.196 165.434 190.004 165.902 189.077 166.848L171.124 185.194L162.56 175.76C161.687 174.799 160.522 174.313 159.343 174.303C158.164 174.293 156.972 174.759 156.045 175.705C154.194 177.598 154.108 180.69 155.853 182.613L167.578 195.528C168.418 196.45 169.574 196.976 170.796 196.986C172.017 196.996 173.204 196.491 174.093 195.582L195.4 173.809C197.251 171.918 197.337 168.824 195.592 166.903Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_839_26531",
    x: 131.248,
    y: 136.74,
    width: 86.7244,
    height: 86.7244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.677445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_839_26531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_839_26531",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.45163
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.94826
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_839_26531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_839_26531",
    x1: 57.2832,
    y1: 47.5557,
    x2: 217.669,
    y2: 113.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#FEE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#FDADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_839_26531",
    x1: 82.1768,
    y1: 83.5088,
    x2: 141.802,
    y2: 132.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#A554E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A554E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_839_26531",
    x1: 82.1768,
    y1: 83.5088,
    x2: 141.802,
    y2: 132.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#A554E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A554E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_839_26531",
    x1: 132.603,
    y1: 222.109,
    x2: 232.014,
    y2: 195.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BDF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_839_26531",
    x1: 213.992,
    y1: 218.291,
    x2: 132.603,
    y2: 218.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69CFB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email_sent.1c2e9c259c14638be23fdf15e965d2f8.svg";
export { ForwardRef as ReactComponent };